import React, {useState} from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {TextFieldDebounced} from 'shells/textfield/textfield-debounced';

type Props = {
    value?: FilterObject;
    onChange: (...args: any) => any;
    name: string;
    isNumber: boolean;
    delay?: number;
};

export const FormTextField = ({value, onChange, name, isNumber, delay = 500}: Props) => {
    const [selectedValue, setValue] = useState(value ? value.data : '');
    const handleTextChange = (textValue: string) => {
        setValue(textValue);
        onChange({
            [name]: {
                data: textValue,
            },
        });
    };

    return (
        <div style={{paddingTop: '12px'}}>
            <TextFieldDebounced
                // @ts-expect-error
                className='ui-input--full-width'
                placeholder='Enter text...'
                value={selectedValue}
                onChange={handleTextChange}
                delay={delay}
                type={isNumber ? 'number' : undefined}
            />
        </div>
    );
};
